module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    on: {
      "click": function($event) {
        return _vm.campaignClick(_vm.campaign)
      }
    }
  }, [_c('td', {
    class: ['sortCenter', _vm.campaignStatus, 'status_text']
  }, [_c('div', [_vm._v(_vm._s(_vm.statusText))])]), _vm._v(" "), _c('td', {
    staticClass: "campaign_name_wrap",
    attrs: {
      "title": _vm.title
    }
  }, [_c('div', {
    staticClass: "campaignName name"
  }, [_vm._v("\n      " + _vm._s(_vm.campaign.campaign_nm) + " \n    ")])]), _vm._v(" "), _c('td', {
    staticClass: "sortCenter date_td"
  }, [_c('div', {
    staticClass: "fr_date_div"
  }, [_vm._v("\n    " + _vm._s(_vm.campaign.campaign_fr_ymd) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "c"
  }, [_vm._v("~")])]), _vm._v(" "), _c('td', {
    staticClass: "sortCenter date_td"
  }, [_c('div', {
    staticClass: "to_date_div"
  }, [_vm._v("\n    " + _vm._s(_vm.campaign.campaign_to_ymd) + " ")])]), _vm._v(" "), _c('td', {
    staticClass: "name_td fr"
  }, [_c('div', {
    staticClass: "sortCenter name",
    attrs: {
      "title": _vm.campaign.client_nm
    }
  }, [_c('span', {
    staticClass: "responsive_text"
  }, [_vm._v("광고주")]), _c('span', {
    staticClass: "responsive_name"
  }, [_vm._v(_vm._s(_vm.campaign.client_nm))])])]), _vm._v(" "), (_vm.custKnd.a) ? _c('td', {
    staticClass: "name_td"
  }, [_c('div', {
    staticClass: "sortCenter name",
    attrs: {
      "title": _vm.campaign.agency_nm
    }
  }, [_c('span', {
    staticClass: "responsive_text"
  }, [_vm._v("에이전시")]), _c('span', {
    staticClass: "responsive_name"
  }, [_vm._v(_vm._s(_vm.campaign.agency_nm))])])]) : _vm._e(), _vm._v(" "), (_vm.custKnd.l) ? _c('td', {
    staticClass: "name_td"
  }, [_c('div', {
    staticClass: "sortCenter name",
    attrs: {
      "title": _vm.campaign.lab_cust_nm
    }
  }, [_c('span', {
    staticClass: "responsive_text"
  }, [_vm._v("랩사")]), _c('span', {
    staticClass: "responsive_name"
  }, [_vm._v(_vm._s(_vm.campaign.lab_cust_nm))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75ba98da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaignList/Result.vue
// module id = 862
// module chunks = 1